/* Lumira de compagnie, mode dodo : elle fait la sieste sur son nuage dans le coin de l'écran.
   Visage animé (data-face) : dort et ronfle, entrouvre un œil, rêve les yeux qui roulent, parle en dormant,
   sursaute avec des yeux globuleux, fait le monstre puis éclate de rire, a la tête qui tourne quand on la secoue.
   Sa croix la fait disparaître pendant 7 jours. */
(() => {
  'use strict';
  const pet = document.querySelector('[data-pet]');
  if (!pet) return;
  const OFF_KEY = 'lumiPetOff', OFF_DAYS = 7;
  try {
    if (sessionStorage.getItem('lumiPet') === 'off') return;
    if (Date.now() - (+localStorage.getItem(OFF_KEY) || 0) < OFF_DAYS * 864e5) return;
  } catch (e) { /* stockage indisponible */ }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sprite = pet.querySelector('[data-pet-sprite]');
  const bubble = pet.querySelector('[data-pet-say]');
  const pick = (a) => a[(Math.random() * a.length) | 0];
  const rand = (a, b) => a + Math.random() * (b - a);

  const dreams = [
    'Zzz… encore 5 minutes… 😴',
    'Rrrrr… pchiouuu… 💤',
    'Je compte les moutons… 1 gourde… 2 gourdes… 🐑',
    'Chut… je rêve de gourdes licornes… 🦄',
    'Zzz… livraison incluse… en France… zzz 🇫🇷',
    'Ne me réveillez pas… sauf pour un câlin… 💜',
    'Mmmh… un chocolat chaud dans un mug qui touille tout seul… ☕',
    'Zzz… la baleine… elle fait pschhh… 🐳',
    'Psst… -10 % sur la 1re commande… touchez-moi… zzz 💌'
  ];
  if (document.documentElement.classList.contains('hw-on')) dreams.push('Zzz… les monstres ne passeront pas… ma veilleuse veille… 🎃', 'Bouh… euh… zzz… 👻');
  if (pet.dataset.page === 'product') dreams.push('Zzz… elle est jolie celle-là… hop dans le panier… 🛒');
  const wakes = [
    'Hein ?! Quoi ?! J’dormais pas ! 😳',
    'Oh ! Coucou… je… je réfléchissais les yeux fermés 😅',
    'Gnn… qui a éteint la lune ? 🌙',
    'Ah ! Vous m’avez fait peur ! 🙀',
    'Oui oui, je suis réveillée… presque… 🥱'
  ];
  const backToSleep = ['Bon… je me rendors… 😴', 'Bonne nuit… euh, bonne journée… 💤', 'On se parle après ma sieste… 🌙'];

  let timers = [], idleTimer, talkTimer, sayTimer, busy = false;
  const later = (fn, ms) => { const t = setTimeout(fn, ms); timers.push(t); return t; };
  const clearAll = () => { timers.forEach(clearTimeout); timers = []; clearTimeout(idleTimer); };
  const face = (f) => { pet.dataset.face = f; };
  const say = (txt, ms = 4200, talking) => {
    clearTimeout(sayTimer);
    bubble.textContent = txt;
    pet.classList.add('is-talking');
    if (talking && pet.dataset.face === 'sleep') { face('talk'); }
    sayTimer = setTimeout(() => { pet.classList.remove('is-talking'); if (pet.dataset.face === 'talk') face('sleep'); }, ms);
  };
  const sleep = () => {
    busy = false;
    pet.classList.remove('is-awake', 'is-jumping');
    pet.classList.add('is-sitting');
    face('sleep');
    scheduleIdle();
  };

  /* Petites mimiques pendant la sieste */
  const scheduleIdle = () => {
    clearTimeout(idleTimer);
    if (reduce) return;
    idleTimer = setTimeout(() => {
      if (busy || pet.dataset.face !== 'sleep' || pet.classList.contains('is-talking')) { scheduleIdle(); return; }
      const r = Math.random();
      if (r < .3) { face('peek'); later(() => { if (!busy) face('sleep'); }, 2600); }
      else if (r < .55) { face('rem'); later(() => { if (!busy) face('sleep'); }, 3400); }
      else if (r < .85) {
        pet.classList.add('is-pop', 'is-jolt');
        later(() => pet.classList.remove('is-jolt'), 400);
        later(() => pet.classList.remove('is-pop'), 1500);
        if (Math.random() < .4) say(pick(['Hein ?… … zzz 💤', 'Pop ! … … zzz', 'Qu’est-ce… ? … rrrr… 😴']), 2200);
      }
      scheduleIdle();
    }, rand(6000, 11000));
  };
  const scheduleDream = (first) => {
    clearTimeout(talkTimer);
    talkTimer = setTimeout(() => {
      if (!busy && pet.dataset.face === 'sleep' && !pet.classList.contains('is-talking')) say(pick(dreams), 4500, true);
      scheduleDream(false);
    }, first ? 2500 : rand(20000, 35000));
  };

  /* Position : posée dans le coin bas gauche, sur son nuage */
  let x = 12, y = 0;
  const width = () => pet.offsetWidth || 110;
  const maxX = () => Math.max(10, window.innerWidth - width() - 10);
  const place = () => { pet.style.setProperty('--px', x + 'px'); pet.style.setProperty('--py', y + 'px'); };
  pet.hidden = false; place(); sleep(); scheduleDream(true);
  window.addEventListener('resize', () => { x = Math.min(x, maxX()); place(); });

  /* Survol (ordinateur) : elle entrouvre un œil */
  sprite.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && !busy && pet.dataset.face === 'sleep') face('peek'); });
  sprite.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && !busy && pet.dataset.face === 'peek') face('sleep'); });

  const wake = () => {
    clearAll(); busy = true;
    pet.classList.remove('is-sitting', 'is-jumping'); void pet.offsetWidth;
    pet.classList.add('is-awake', 'is-jumping');
  };
  const goBackToSleep = (delay) => {
    later(() => { face('drowsy'); say(pick(backToSleep), 2600); }, delay);
    later(sleep, delay + 2600);
  };

  /* Toucher : sursaut, mode monstre ou un seul œil… puis dodo */
  const poke = (cx, cy) => {
    wake();
    if (window.LagonFountain) window.LagonFountain(cx, cy, 120, 3);
    else if (window.LagonBurst) window.LagonBurst(cx, cy, 30, 2, 110);
    const r = Math.random();
    if (r < .45) { face('startle'); say(pick(wakes), 2400); goBackToSleep(2000); }
    else if (r < .85) {
      face('monster'); say('BOUH ! 👻', 1400);
      later(() => { face('giggle'); say('Hihi ! Je vous ai bien eu 😜', 1800); }, 1400);
      goBackToSleep(3300);
    } else { face('peek'); pet.classList.remove('is-awake'); pet.classList.add('is-sitting'); say('Hmm ?… non, pas maintenant… 😴', 2200); later(sleep, 2400); }
  };
  sprite.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    const r = sprite.getBoundingClientRect(); poke(r.left + r.width / 2, r.top + r.height / 3);
  });

  /* Attraper et lâcher : la tête qui tourne, puis retour sur le nuage */
  let down = null;
  sprite.addEventListener('pointerdown', (e) => {
    down = { sx: e.clientX, sy: e.clientY, ox: x, oy: y, moved: false };
    sprite.setPointerCapture(e.pointerId);
  });
  sprite.addEventListener('pointermove', (e) => {
    if (!down) return;
    const dx = e.clientX - down.sx, dy = e.clientY - down.sy;
    if (!down.moved && Math.hypot(dx, dy) < 6) return;
    if (!down.moved) { down.moved = true; wake(); pet.classList.remove('is-jumping'); pet.classList.add('is-dragging'); face('dizzy'); say('Oh là là… tout tourne… 😵‍💫', 2200); }
    x = Math.min(Math.max(down.ox + dx, 0), maxX());
    y = Math.min(0, down.oy + dy);
    place();
  });
  const release = (e) => {
    if (!down) return;
    const wasDrag = down.moved; down = null;
    if (!wasDrag) { poke(e.clientX, e.clientY); return; }
    pet.classList.remove('is-dragging'); pet.classList.add('is-falling');
    let vy = 0;
    const fall = () => {
      vy += 1.2; y = Math.min(0, y + vy); place();
      if (y < 0 && !reduce) requestAnimationFrame(fall);
      else { y = 0; place(); pet.classList.remove('is-falling'); say('Pouf… sur mon nuage… 😵‍💫', 2000); goBackToSleep(1800); }
    };
    requestAnimationFrame(fall);
  };
  sprite.addEventListener('pointerup', release);
  sprite.addEventListener('pointercancel', () => { down = null; pet.classList.remove('is-dragging'); y = 0; place(); sleep(); });

  /* La croix : grand sourire, et elle s'en va dormir ailleurs pendant 7 jours */
  pet.querySelector('[data-pet-close]').addEventListener('click', (e) => {
    e.stopPropagation();
    clearAll(); clearTimeout(talkTimer); busy = true;
    face('bye');
    say('D’accord… je vais dormir ailleurs… bonne visite ! 💜', 1400);
    pet.classList.add('is-leaving');
    setTimeout(() => { pet.hidden = true; }, reduce ? 0 : 1300);
    try { sessionStorage.setItem('lumiPet', 'off'); localStorage.setItem(OFF_KEY, String(Date.now())); } catch (err) { /* ignore */ }
    const card = document.querySelector('[data-pet-card]');
    if (card && !card.hidden) { const x2 = card.querySelector('[data-card-close]'); if (x2) x2.click(); }
  });
})();